import React from "react"
import Attribute from "../RenderRowAttribute"
import CheckboxAttribute from "./form/Checkbox"
import TextAttribute from "./form/Text"
import DropdownAttribute from "./form/Dropdown"
import FormulasAttribute from "./form/Formulas"
import ObjectFiltersAttribute from "./form/objectFilters"
import ObjectOrderAttribute from "./form/objectOrder"
import BlockPicker from "../../../studio/components/BlockPicker"
import ObjectPicker from "../../../studio/components/ObjectPicker"
import SortableFieldsPicker from "../../../studio/components/SortableFieldsPicker"
import Modal from "ui/components/Modal"
import Button from "ui/components/Button"
import KeyValueList from "../../../studio/ui/KeyValueList"

export const text = (attributeProps = {}, renderedElementProps = {}) => (
    <Attribute
        field="sortBy"
        label="sort by"
        render={props => <TextAttribute label="Sort By" {...props} {...renderedElementProps} />}
        {...attributeProps}
    />
)

export const keyvaluelist = (attributeProps = {}, renderedElementProps = {}) => (
    <Attribute
        render={props => (
            <KeyValueList
                keyName={attributeProps.key}
                valueName={attributeProps.value}
                {...props}
                {...renderedElementProps}
            />
        )}
        {...attributeProps}
    />
)

export const image = (attributeProps = {}, renderedElementProps = {}) => (
    <Attribute
        field="sortBy"
        label="sort by"
        render={props => <TextAttribute label="Sort By" {...props} {...renderedElementProps} />}
        {...attributeProps}
    />
)

export const multiline = (attributeProps = {}, renderedElementProps = {}) => (
    <Attribute
        field="sortBy"
        label="sort by"
        render={props => (
            <TextAttribute multiline label="Sort By" {...props} {...renderedElementProps} />
        )}
        {...attributeProps}
    />
)

export const boolean = attributeProps => (
    <Attribute {...attributeProps} render={props => <CheckboxAttribute {...props} />} />
)

export const options = attributeProps => (
    <Attribute {...attributeProps} render={props => <DropdownAttribute {...props} />} />
)
export const formulas = attributeProps => (
    <Attribute {...attributeProps} render={props => <FormulasAttribute {...props} />} />
)
export const objectFilters = attributeProps => (
    <Attribute
        {...attributeProps}
        render={props => (
            <ModalAttribute label={props.label}>
                <ObjectFiltersAttribute {...props} />
            </ModalAttribute>
        )}
    />
)
export const objectOrder = attributeProps => (
    <Attribute {...attributeProps} render={props => <ObjectOrderAttribute {...props} />} />
)
export const blocks = attributeProps => (
    <Attribute {...attributeProps} render={props => <BlockPicker {...props} />} />
)

export const objectPicker = attributeProps => (
    <Attribute {...attributeProps} render={props => <ObjectPicker {...props} />} />
)
export const fieldPicker = attributeProps => {
    return (
        <Attribute
            {...attributeProps}
            render={props => {
                const objectId = props.params["objectId"]
                if (!objectId) {
                    return ""
                }
                return <SortableFieldsPicker objectId={objectId} {...props} />
            }}
        />
    )
}

class ModalAttribute extends React.Component {
    state = {
        open: false,
    }
    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })
    render() {
        return (
            <React.Fragment>
                <Button onClick={this.open}>edit {this.props.label}</Button>
                <Modal isOpen={this.state.open} onRequestClose={this.close}>
                    {this.props.children}
                </Modal>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/primitives.js